/**
 * Announcement Modal Module
 * Shows/hides announcement popup with 24h localStorage persistence.
 */
function initAnnouncementModal() {
  const popup = document.getElementById('announcement-popup');
  const closeBtn = document.getElementById('close-announcement-popup');
  const closeBtnFooter = document.getElementById('close-announcement-btn');
  const storageKey = 'centrostal_popup_closed_time';

  if (!popup) return;

  // Check urgent flag
  if (popup.dataset.urgent === 'true') {
    popup.classList.add('popup--urgent');
  }

  // Check 24h localStorage persistence
  const lastClosed = localStorage.getItem(storageKey);
  const now = Date.now();
  const twentyFourHours = 24 * 60 * 60 * 1000;

  if (lastClosed) {
    if (now - parseInt(lastClosed, 10) < twentyFourHours) {
      popup.style.display = 'none';
      return;
    }
    localStorage.removeItem(storageKey);
  }

  popup.style.display = 'flex';

  function closePopup(e) {
    e.preventDefault();
    e.stopPropagation();
    popup.style.display = 'none';
    localStorage.setItem(storageKey, Date.now().toString());
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (closeBtnFooter) closeBtnFooter.addEventListener('click', closePopup);
}
